import pathStore from "../store/pathStore";
import treeStore from "../store/treeStore";

/**
 * checks the character to ensure nothing unwanted in there
 * @param {*} e charcter to check
 */
export function characterCheck(e) {
    // var regex = new RegExp("^[a-zA-Z0-9]+$");
    // eslint-disable-next-line
    var regex = new RegExp("^[a-zA-Z0-9 \s]+$");
    var key = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    if (!regex.test(key)) {
        e.preventDefault();
        return false;
    }
}

/**
 * shortname generator from pauls site creator 1
 * @param {} name name you wnat to shorten
 */
export function shortnameGenerator(name) {
    const specialregex = /[^a-z0-9]/g;
    const vowelregex = /[aeiou]/g;
    const wordspace = name.toLowerCase().split(' ');
    const newElement = [];
    const maxwords = Math.min(wordspace.length, 5);
    const maxwordlength = 5;

    /** Short names can just be used (one word, trimmed to maxwordlength) -  example 'IT' becomes 'it', 'Communications' becomes 'commn' */
    if (maxwords === 1) {
        newElement.push(wordspace[0].replace(specialregex, '').slice(0, maxwordlength));
    } else {
        for (let _i = 0; _i < maxwords; _i++) {
            newElement.push(wordspace[_i].replace(specialregex, '').replace(vowelregex, '').slice(0, maxwordlength));
        }
    }

    return newElement.join('');
}

export function shortNameClashGlobalCheck(shortName, nodeId) {
    let treeKeys = [];
    let shortNames = [];

    Object.keys(treeStore.tree).forEach((treeKey) => {
        treeKeys.push(treeKey);
    });
    if (treeKeys.length >= 1) {
        const tree = treeKeys.filter((node) => {
            return node !== nodeId;
        });
        shortNames = tree.map((node) => {
            return treeStore.tree[node].shortName;
        });
        let amendedName = '';
        if (shortNames.length >= 1) {
            if (shortNames.indexOf(shortName) > -1) {
                /* Clash, amend */
                ;
                let lastChar = parseInt(shortName.slice(-1), 10);
                if (isNaN(lastChar)) {
                    amendedName = shortName + '1';
                } else {
                    amendedName = shortName.substr(0, shortName.length - 1) + (++lastChar);
                }
                /* Now check our new string against the siblings */
                return shortNameClashGlobalCheck(amendedName, nodeId);
            } else {
                ;
                return shortName;
            }
        } else {
            return shortName;
        }
    } else {
        return shortName;
    }
    // return shortName;
}
/**
 * Check the siblings of this node for shortName clashes, amending url as required.  Silent, user doesn't see this
 * @param {*} shortName the name to check the class
 * @param {*} parentId the parent node to check all the way down
 */
export function shortNameClashCheck(shortName, parentId) {
    let _temp;
    let siblingShortNames = [];

    if (pathStore.relationship[parentId]) {
        _temp = pathStore.relationship[parentId].children;
    }

    /* Filter out this node if it's a sibling - we don't check against ourselves if this is an edit */
    if (_temp) {
        const siblings = _temp.filter((node) => {
            return node !== parentId;
        });
        // eslint-disable-next-line
        siblingShortNames = siblings.map((node) => {
            if (treeStore.tree[node]) {
                return treeStore.tree[node].shortName;
            }
        });

        return shortNameIndex(siblingShortNames, shortName, parentId);
    }
    return shortName;
}

function shortNameIndex(shortNameTree, shortName, nodeId) {
    let amendedName = '';

    if (shortNameTree.indexOf(shortName) > -1) {
        /* Clash, amend */

        let lastChar = parseInt(shortName.slice(-1), 10);
        if (isNaN(lastChar)) {

            amendedName = shortName + '1';
        } else {

            amendedName = shortName.substr(0, shortName.length - 1) + (++lastChar);
        }
        /* Now check our new string against the siblings */
        return shortNameClashCheck(amendedName, nodeId);
    } else {
        return shortName;
    }
}

export function isEqual(a, b) {
    if (a === null || b === null 
        || a === undefined || b === undefined) {
        return false;
    }
    let aProps = Object.getOwnPropertyNames(a);
    let bProps = Object.getOwnPropertyNames(b);

    if (aProps.length !== bProps.length) {
        return false;
    }

    for (let i = 0; i < aProps.length; i++) {
        let propName = aProps[i];
        if (a[propName] !== b[propName]) {
            return false;
        }
    }
    return true;
}


// WEBPACK FOOTER //
// ./src/services/utils.js